'use strict';

/* ================================================
   FEAR GARAGE — THEME JS
   Handles: cart AJAX, mobile menu, variant
   selection, toast notifications, keyboard nav
================================================ */

// ── MONEY FORMATTING ──────────────────────────
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

// ── TOAST ─────────────────────────────────────
let toastTimer;
function showToast(msg, success = true) {
  clearTimeout(toastTimer);
  const el  = document.getElementById('toast');
  const ic  = document.getElementById('toast-ic');
  const txt = document.getElementById('toast-txt');
  if (!el) return;
  txt.textContent = msg;
  ic.style.background = success ? '#16a34a' : '#DC2626';
  ic.innerHTML = success
    ? `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg>`
    : `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
  el.classList.add('show');
  toastTimer = setTimeout(() => el.classList.remove('show'), 3200);
}

// ── MOBILE MENU ───────────────────────────────
function menuToggle() {
  const menu = document.getElementById('mobile-menu');
  const btn  = document.getElementById('ham-btn');
  if (!menu || !btn) return;
  const open = menu.classList.toggle('open');
  btn.classList.toggle('open', open);
  btn.setAttribute('aria-expanded', open);
  menu.setAttribute('aria-hidden', !open);
  document.body.style.overflow = open ? 'hidden' : '';
}

function menuClose() {
  const menu = document.getElementById('mobile-menu');
  const btn  = document.getElementById('ham-btn');
  if (!menu || !btn) return;
  menu.classList.remove('open');
  btn.classList.remove('open');
  btn.setAttribute('aria-expanded', 'false');
  menu.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// Close menu when a link is clicked
document.querySelectorAll('.mobile-menu__links a').forEach(a => {
  a.addEventListener('click', menuClose);
});

// ── CART COUNT ────────────────────────────────
function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (!el) return;
  el.textContent = count > 0 ? count : '';
  count > 0 ? el.classList.add('visible') : el.classList.remove('visible');
  const btn = document.getElementById('cart-btn');
  if (btn) btn.setAttribute('aria-label', `Open cart, ${count} item${count !== 1 ? 's' : ''}`);
}

// ── CART DRAWER ───────────────────────────────
function cartDrawerOpen() {
  document.getElementById('cart-scrim')?.classList.add('open');
  document.getElementById('cart-drawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function cartDrawerClose() {
  document.getElementById('cart-scrim')?.classList.remove('open');
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}

function cartDrawerToggle() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  if (drawer.classList.contains('open')) {
    cartDrawerClose();
  } else {
    fetchAndRenderCart().then(cartDrawerOpen);
  }
}

// ── CART API ──────────────────────────────────
async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function cartAdd(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || window.cartStrings?.error || 'Error adding item');
  return data;
}

async function cartChange(line, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line, quantity })
  });
  return res.json();
}

// ── RENDER CART DRAWER ────────────────────────
async function fetchAndRenderCart() {
  const cart = await fetchCart();
  renderCartDrawer(cart);
  updateCartCount(cart.item_count);
  return cart;
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cart-body');
  const ft   = document.getElementById('cart-ft');
  if (!body) return;

  if (!cart.items || cart.items.length === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg>
        <p>Your cart is empty.<br>Add something sick.</p>
        <button class="btn btn-outline" style="height:40px;padding:0 18px;font-size:10px;" onclick="cartDrawerClose()">Browse Shop</button>
      </div>`;
    if (ft) ft.style.display = 'none';
    return;
  }

  body.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item">
      <div class="cart-item__img">
        ${item.image
          ? `<img src="${item.image}" alt="${item.title}" loading="lazy">`
          : ''}
      </div>
      <div class="cart-item__info">
        <div class="cart-item__name">${item.product_title}</div>
        <div class="cart-item__var">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="cart-item__row">
          <div class="qty">
            <button class="qty-btn" onclick="cartUpdateLine(${i + 1}, ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span class="qty-n">${item.quantity}</span>
            <button class="qty-btn" onclick="cartUpdateLine(${i + 1}, ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.line_price)}</span>
        </div>
      </div>
    </div>`).join('');

  if (ft) {
    ft.style.display = 'block';
    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }
}

async function cartUpdateLine(line, quantity) {
  const cart = await cartChange(line, quantity);
  renderCartDrawer(cart);
  updateCartCount(cart.item_count);
}

// ── PRODUCT PAGE — IMAGE GALLERY ──────────────
let pgIndex = 0;

// Hover the main image → preview the "other side" (next image)
function pgHover(entering) {
  const back = document.getElementById('pg-main-img-back');
  if (!back) return;
  const imgs = window.productImages || [];
  if (imgs.length < 2) return;
  if (entering) {
    const next = (pgIndex + 1) % imgs.length;
    back.src = imgs[next];
    back.style.opacity = '1';
  } else {
    back.style.opacity = '0';
  }
}

// Tap the main image → flip to the next image (mobile-friendly)
function pgFlip() {
  const imgs = window.productImages || [];
  if (imgs.length < 2) return;
  const next = (pgIndex + 1) % imgs.length;
  const thumbs = document.querySelectorAll('.pg__thumb');
  pgSelect(next, thumbs[next]);
}

// Tap a thumbnail → set the main image (mobile-friendly)
function pgSelect(index, btn) {
  const imgs = window.productImages || [];
  if (!imgs[index]) return;
  pgIndex = index;
  const main = document.getElementById('pg-main-img');
  const back = document.getElementById('pg-main-img-back');
  if (main) main.src = imgs[index];
  if (back) back.style.opacity = '0';
  document.querySelectorAll('.pg__thumb').forEach(t => t.classList.remove('active'));
  if (btn) btn.classList.add('active');
}

// ── PRODUCT PAGE — VARIANT SELECTION ─────────
let selectedVariantId = null;
let selectedOptions = {};

function selectOption(btn) {
  const position = btn.dataset.optionPosition;
  const value    = btn.dataset.optionValue;

  // Deselect other buttons in the same option group
  document.querySelectorAll(`.size-btn[data-option-position="${position}"]`)
    .forEach(b => b.classList.remove('sel'));
  btn.classList.add('sel');

  // Track selected option
  selectedOptions[position] = value;

  // Update visible size label
  const labelEl = document.getElementById('size-selected-label');
  if (labelEl) labelEl.textContent = value;

  // Find the matching variant from all product variants
  const variants = window.productVariants || [];
  const match = variants.find(v => {
    return Object.keys(selectedOptions).every(pos => v['option' + pos] === selectedOptions[pos]);
  });

  if (match) {
    selectedVariantId = match.id;
    document.querySelectorAll('.product-section__price, .product-section__sticky-price')
      .forEach(el => el.textContent = formatMoney(match.price));
  } else {
    // Partial match — at least lock in a variant for this option alone
    const partial = variants.find(v => v['option' + position] === value);
    if (partial) selectedVariantId = partial.id;
  }
}

async function addToCartFromPage() {
  const btn = document.getElementById('atc-btn');
  if (!btn) return;

  // If no variant selected yet and there are size options, shake the grid
  if (!selectedVariantId) {
    const sizeGrid = document.getElementById('size-grid');
    if (sizeGrid) {
      sizeGrid.classList.add('shake');
      sizeGrid.addEventListener('animationend', () => sizeGrid.classList.remove('shake'), { once: true });
    }
    showToast('Please select a size', false);
    return;
  }

  btn.classList.add('loading');
  btn.textContent = 'Adding…';

  try {
    await cartAdd(parseInt(selectedVariantId));
    await fetchAndRenderCart();
    btn.classList.remove('loading');
    btn.classList.add('done');
    btn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> Added!`;
    showToast('Added to cart');
    setTimeout(() => cartDrawerOpen(), 500);
    setTimeout(() => {
      btn.classList.remove('done');
      btn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart`;
    }, 3000);
  } catch (err) {
    btn.classList.remove('loading');
    btn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart`;
    showToast(err.message, false);
  }
}

// Quick-add from collection/home grid
async function quickAdd(variantId, productTitle) {
  try {
    await cartAdd(parseInt(variantId));
    await fetchAndRenderCart();
    showToast(`${productTitle} added to cart`);
    setTimeout(() => cartDrawerOpen(), 400);
  } catch (err) {
    showToast(err.message, false);
  }
}

// ── KEYBOARD NAV ──────────────────────────────
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (document.getElementById('cart-drawer')?.classList.contains('open')) { cartDrawerClose(); return; }
  if (document.getElementById('mobile-menu')?.classList.contains('open')) { menuClose(); }
});

// ── INIT ──────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  // Set initial cart count from server-rendered value
  const countEl = document.getElementById('cart-count');
  if (countEl) {
    const n = parseInt(countEl.textContent) || 0;
    if (n > 0) countEl.classList.add('visible');
  }

  // Do not auto-select a size — customer must choose explicitly

  // ── SCROLL REVEAL ───────────────────────────
  const rvEls = document.querySelectorAll('.rv');
  if (rvEls.length) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      rvEls.forEach(el => el.classList.add('in'));
    } else {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      rvEls.forEach(el => io.observe(el));
    }
  }
});
